import { useState } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { loginBackoffice } from '@/api/backofficeAuth';

interface LoginPageProps {
    onAuthenticated: () => void;
}

export function LoginPage({ onAuthenticated }: LoginPageProps) {
    const [value, setValue] = useState('');
    const [invalid, setInvalid] = useState(false);
    const [pending, setPending] = useState(false);

    async function handleSubmit(event: React.FormEvent) {
        event.preventDefault();
        setPending(true);
        const ok = await loginBackoffice(value.trim());
        setPending(false);
        if (!ok) {
            setInvalid(true);
            return;
        }
        onAuthenticated();
    }

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
                p: 2,
            }}
        >
            <Paper component="form" onSubmit={handleSubmit} sx={{ p: 4, width: 420 }}>
                <Typography variant="h5" sx={{ mb: 1 }}>
                    BYO Health Backoffice
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                    Exchanged once for an httpOnly cookie the hub sets — never stored or read back
                    by this page. Left empty, the hub accepts requests unauthenticated (its
                    local-dev default).
                </Typography>
                <TextField
                    autoFocus
                    fullWidth
                    label="BACKOFFICE_TOKEN"
                    type="password"
                    value={value}
                    onChange={(event) => {
                        setValue(event.target.value);
                        setInvalid(false);
                    }}
                    error={invalid}
                    helperText={invalid ? 'Invalid token' : ' '}
                    sx={{ mb: 2 }}
                />
                <Button type="submit" variant="contained" fullWidth disabled={pending}>
                    Continue
                </Button>
            </Paper>
        </Box>
    );
}
